export function getNestedChildren(hostElement: Element, tagName: string): HTMLCollectionOf<Element> {
  return hostElement.getElementsByTagName(tagName);
}

export function getNestedChildrenOf<T extends Element>(hostElement: Element, tagName: string): HTMLCollectionOf<T> {
  const elements = getNestedChildren(hostElement, tagName);
  return <HTMLCollectionOf<T>>(elements as unknown);
}

export function getFirstNestedChild<T>(hostElement: Element, tagName: string): T {
  const slottedElements = getNestedChildren(hostElement, tagName);
  return slottedElements.length > 0 ? ((slottedElements[0] as unknown) as T) : null;
}

/**
 * Returns the width of the host element's parent container
 * @param the child element whose parent element is targeted
 * @example getParentWidth(this.hostElement)
 */
export function getParentWidth(hostElement: Element): number {
  return hostElement?.parentElement ? hostElement.parentElement.offsetWidth : 0;
}

export function elementHasDimensions(hostElement: HTMLElement, callback) {
  const hasDimensions = new Promise((resolve) => {
    const checkDimension = () => {
      if (!hostElement.clientWidth) {
        requestAnimationFrame(() => checkDimension());
      } else {
        resolve("Found");
      }
    };
    checkDimension();
  });

  hasDimensions.then(() => {
    callback();
  });
}
